import BaseService from "./BaseService";

export type AdminModelFeedbackRow = {
    id: string;
    audioMetadataId: string;
    classifierId: string;
    modelName: string;
    classifierImplementationId: string | null;
    version: number | null;
    evaluationId: string | null;
    agreed: boolean;
    note: string | null;
    userId: string | null;
    userName: string;
    createdOn: string;
    modifiedOn: string;
};

export type AdminModelFeedbackPage = {
    items: AdminModelFeedbackRow[];
    total: number;
    agreements: number;
    disagreements: number;
};

export type FeedbackFilters = {
    search: string;
    model: string;
    version: string;
    user: string;
    agreed: string;
    source: string;
    hasNote: string;
    from: string;
    to: string;
};

export const emptyFeedbackFilters: FeedbackFilters = {
    search: "",
    model: "",
    version: "",
    user: "",
    agreed: "",
    source: "",
    hasNote: "",
    from: "",
    to: "",
};

export class AdminModelFeedbackService extends BaseService {
    protected urlBase = "api/AdminModelFeedback";

    getPage(
        organizationId: string,
        page: number,
        pageSize: number,
        sort: string,
        descending: boolean,
        filters: FeedbackFilters,
    ) {
        const parameters = new URLSearchParams({
            organizationId,
            page: String(page),
            pageSize: String(pageSize),
            sort,
            descending: String(descending),
        });
        Object.entries(filters).forEach(([key, value]) => {
            if (!value) return;
            if (key === "from" || key === "to") {
                // Date inputs represent inclusive local calendar dates; API end is exclusive.
                const date = new Date(`${value}T00:00:00`);
                if (key === "to") date.setDate(date.getDate() + 1);
                parameters.set(key, date.toISOString());
            } else parameters.set(key, value);
        });
        return this.get<AdminModelFeedbackPage>(parameters, "");
    }
}
